<template>
  <div class="w100 bg-w pt20 pb20">
    <div class="w120 mc pt20 pb20" v-for="item in moduleData.cardModules" :key="item.code">
      <p class="w100 mb20 font-36 tx-c">信息导航</p>
      <el-row :gutter="20">
        <el-col class="mb20" :style="`width: ${handleWidth(item.col || 5)};`" v-for="e in item.data" :key="e.navId" @click="openLink(e)">
          <div class="w100 font-20 cu-p tx-c item-box ellipsis" @click="openLink(e)">{{e.navName}}</div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "LINK",
  components: {},
  props: ['moduleData'],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
    };
  },
  computed: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    handleWidth(col){
      switch (col) {
        case 1:
          return '100%'
        case 2:
          return '50%'
        case 3:
          return '33.3%'
        case 4:
          return '25%'
        case 5:
          return '20%'
        case 6:
          return '16.6%'
        default:
          return '50%'
      }
    },
    openLink(item){
      let url = item.navUrl;
      if(url.indexOf('http') < 0){
        url = 'http://' + url;
      }
      window.open(url);
    }
  },
  watch: {},
  filters: {},
};
</script>

<style scoped>
.item-box {
  height: 58px;
  line-height: 58px;
  border-radius: 4px;
  background: rgba(238, 244, 249, 1);
}

.item-box:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
</style>
